import { render, staticRenderFns } from "./SMSendPaymentDialog.vue?vue&type=template&id=68121bb1&"
import script from "./SMSendPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./SMSendPaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports